import { defineComponent as _defineComponent } from 'vue'
import {
	ref,
	Ref,
	computed,
	ComputedRef,
	withDefaults,
	Component,
} from "vue";
import store from "@/vue/planning/store/store";
import PrestationPopup from "@/vue/planning/components/result/prestationPopup.vue";
import PrestationPictureDesktop from "@/vue/planning/components/result/prestation/pictureDesktop.vue";
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";
import DetailsTop from "@/vue/planning/components/result/prestation/detailsTop.vue";
import PrestVariantDefault from "@/vue/planning/components/result/prestation/PrestVariantDefault.vue";
import PrestVariantPierreVacance from "@/vue/planning/components/result/prestation/PrestVariantPierreVacance.vue";
import PopupBase from "@/vue/common/popupBase.vue";
import { isPierreVacance } from "@/vue/planning/logic/pv";
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";

import { Prestation } from "@/types";

interface Props {
	prestation: Prestation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'prestation',
  props: {
    prestation: { default: {} }
  },
  setup(__props: any) {

const props = __props as { prestation: Prestation }



// refs
const isPopupOpen: Ref<boolean> = ref(false);

// computed

const image: ComputedRef<string> = computed(() => {
	const images = props.prestation?.picturesAccomodation || [];
	if (images.length === 0) return "";

	const img = images[0];
	return (
		img["imgSmall"] ||
		img["imgMedium"] ||
		img["imgLarge"] ||
		img["imgXL"] ||
		img["img"] ||
		""
	);
});
const isDisplayPlaceholders: ComputedRef<boolean> = computed(() => {
	return Object.keys(props.prestation).length === 0;
});
const isSelected: ComputedRef<boolean> = computed(() => {
	if (!props.prestation || !props.prestation.variants) return false;
	for (const variant of props.prestation.variants) {
		if (store.state.selectedPrestIds[variant.id]) return true;
	}
	return false;
});

// methods
const getPrestComponent = (variant: any): Component => {
	if (isPierreVacance(variant)) {
		return PrestVariantPierreVacance;
	}
	return PrestVariantDefault;
};
const handleClosePopup = () => {
	isPopupOpen.value = false;
};

const handleOpenPopup = () => {
	isPopupOpen.value = true;
};

const handleSelect = (id: string) => {
	const obj: { [key: string]: number } = {};
	obj[id] = 1;
	store.dispatch("setSelectedPrestIds", obj);
};

const handleClear = (id: string) => {
	const obj: { [key: string]: number } = {};
	obj[id] = 0;
	store.dispatch("setSelectedPrestIds", obj);
};

const handleDropdownSelect = (something: any) => {
	const { newSelected, id } = something;
	const obj: { [key: string]: number } = {};
	obj[id] = newSelected;
	store.dispatch("setSelectedPrestIds", obj);
};

const handleDropdownClick = (obj: any) => {
	if (store.state.selectDropdownOpen_prestId === obj.id) {
		obj["id"] = "";
	}
	store.dispatch("setSelectDropdownOpen_prestId", obj);
};

return { __sfc: true,props, isPopupOpen, image, isDisplayPlaceholders, isSelected, getPrestComponent, handleClosePopup, handleOpenPopup, handleSelect, handleClear, handleDropdownSelect, handleDropdownClick, PrestationPopup, PrestationPictureDesktop, BorderHorizontal, DetailsTop, PrestVariantDefault, PopupBase }
}

})